import React from "react";
import RpTextField from "./RpTextField";

type FormikTextFieldProps = {
  field: {
    name: string;
    value: unknown;
    onChange: (_event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (_event: React.FocusEvent<HTMLInputElement>) => void;
  };
  form: {
    touched: Record<string, boolean | undefined>;
    errors: Record<string, React.ReactNode>;
  };
  onChange?: (_event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (_event: React.FocusEvent<HTMLInputElement>) => void;
  [key: string]: unknown;
};

export default function RpFormikTextField({
  field,
  form: { touched, errors },
  onChange,
  onBlur,
  ...rest
}: FormikTextFieldProps) {
  const errorText =
    touched[field.name] && errors[field.name] ? errors[field.name] : "";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    onChange?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    field.onBlur(e);
    onBlur?.(e);
  };

  return (
    <RpTextField
      {...rest}
      name={field.name}
      value={field.value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={!!errorText}
      helperText={errorText}
    />
  );
}
